import { IGlobals } from '../../interfaces'
import {
  PREFILL_CART_LIMIT,
  RECOMMENDATION_CAROUSEL_LIMIT,
  RECOMMENDATION_LIST_LIMIT,
  TemplateActionNames,
} from './defaultConstants'
import { cartLabels } from './defaultGlobals/cartLabels'
import { sideContentMap } from './defaultGlobals/sideContent'
import { tagsMap } from './defaultGlobals/tags'

const globals: IGlobals = {
  navMenu: 'tabs',
  counter: {
    step: 1,
    activeInput: true,
    max: null,
    modifierMap: {},
    allowRetryWhenOutOfStock: false,
    clampTypedInputToCap: false,
    allowTypedZero: false,
    // Emptying a field removes the line when this is on, and the gesture that
    // commits it is tapping away — so the default must stay false until a
    // storefront opts in, exactly as for allowTypedZero above. Inert on its own:
    // the library gates it behind allowTypedZero as well.
    allowEmptyInputAsZero: false,
    disableWhileSyncing: false,
  },
  packages: {
    sort: {
      enabled: false,
      field: 'quantity',
      direction: 'asc',
    },
  },
  promotions: {
    // Adds a stock request to every product page that shows a combo or
    // complex promotion's add-all button, and can disable a button that works
    // with the flag off, so it stays off until a storefront opts in.
    disableUnfulfillableAddAll: false,
  },
  catalog: {
    layout: 'default',
    fieldsToDisplay: {},
    memoizeItems: false,
  },
  summaryList: {
    fieldsToDisplay: [
      'name',
      'quantity',
      'description',
      'unitPrice',
      'totalFee',
      'promotion',
    ],
    summaryFieldsToDisplay: [
      'subtotal',
      'discounts',
      'taxes',
      'perceptions',
      'administrativeServices',
    ],
    summaryAlerts: {
      summaryAlertOnMinAmount: {
        value: null,
      },
    },
  },
  text: {
    // Product descriptions are tenant-supplied and may carry active HTML;
    // sanitise them fleet-wide. A storefront can set this to 'html' to keep
    // raw rendering if it must.
    descriptionFormat: 'sanitized',
  },
  price: {
    packagePriceMap: {},
  },
  unitPrice: {
    showUnitPrice: false,
    unitsInline: false,
  },
  minAmount: {
    showAmount: false,
    showIndicator: true,
  },
  tags: {
    items: [
      'item.linkedProducts',
      'item.attributes',
      'item.stock',
      'item.outOfStock',
    ],
    map: tagsMap,
  },
  sideContent: {
    items: ['item.attributes'],
    map: sideContentMap,
  },
  imageConfig: {
    resizeEnabled: false,
    imageSizes: {
      cartImage: '50x50',
      catalogueImage: '250x250',
      suggestedItemImage: '100x100',
      productDetailImage: '500x500',
      searchImage: '100x100',
      filterImage: '100x100',
      frequentlyBoughtTogetherImage: '250x250',
    },
  },
  cartLabels,
  recommendedProducts: {
    allRecommendations: 100,
    widgetHome: 5,
    carouselLimit: RECOMMENDATION_CAROUSEL_LIMIT,
    listLimit: RECOMMENDATION_LIST_LIMIT,
  },
  prefillCart: {
    createOrder: false,
    limit: PREFILL_CART_LIMIT,
  },
  placeOrderFlow: {
    actions: [
      TemplateActionNames.CART_GET_FREQUENTLY_BOUGHT_TOGETHER,
      TemplateActionNames.LINKED_PRODUCTS_GET_ITEMS,
      TemplateActionNames.CART_PLACE_ORDER,
    ],
    pushAfter: '',
  },
  footer: {
    priceDisplay: '{{symbol}}{{price}}{{code}}',
    feeDisplay: '+ {{symbol}}{{price}}{{code}}',
  },
  searchBar: {
    searchTermMinLength: 3,
    searchTimeout: 1200,
    searchTermsExceptions: [],
  },
}

export default globals
